module.exports = __webpack_public_path__ + "static/empty-iphone-542ef6ad0fd1039c83dd0847978a6030.png";